import store from "./store";

export default (text, color) => {
    store.commit("mutate", {
        toast: {
            active: true,
            text: text,
            color: color
        }
    });
};